import { render } from "./tep-av-add-address-btn.vue?vue&type=template&id=5b503fb5&scoped=true"
import script from "./tep-av-add-address-btn.vue?vue&type=script&setup=true&lang=js"
export * from "./tep-av-add-address-btn.vue?vue&type=script&setup=true&lang=js"

import "./tep-av-add-address-btn.vue?vue&type=style&index=0&id=5b503fb5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b503fb5"],['__file',"src/views/tep/tep-grid/components/tep-av-add-address-btn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b503fb5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b503fb5', __exports__)) {
    api.reload('5b503fb5', __exports__)
  }
  
  module.hot.accept("./tep-av-add-address-btn.vue?vue&type=template&id=5b503fb5&scoped=true", () => {
    api.rerender('5b503fb5', render)
  })

}


export default __exports__